import { api, apiAntigo } from "services/axios/api";
import { getErrorsByApi } from "shared/helpers/getErrorsByApi";
import {
  IClienteCemDelphi,
  IPaginacaoExtranet,
  IPaginacaoExtranetParams,
  IIdSerialResponse,
} from "shared/interfaces/serial";

/**
 * Lista clientes CEM DELPHI da Extranet via backend novo.
 * 
 * Endpoint: GET /api/Cem/clientes-delphi
 * 
 * O backend novo faz proxy para a API da Extranet.
 * Em ambiente local sem Extranet, retorna lista vazia.
 */
export const listarClientesCemDelphi = async (
  paginacao: IPaginacaoExtranetParams
): Promise<IPaginacaoExtranet<IClienteCemDelphi>> => {
  const queryParams = new URLSearchParams({
    pageIndex: paginacao.pageIndex.toString(),
    pageSize: paginacao.pageSize.toString(),
    sort: paginacao.sort || "id",
    desc: paginacao.desc ? "true" : "false",
    globalFilter: paginacao.globalFilter || "",
  });

  const url = `/Cem/clientes-delphi?${queryParams.toString()}`;

  try {
    const { data } = await api.get<any>(url);

    const dados = data?.dados || data?.Dados || [];
    const paginas = data?.paginas ?? data?.Paginas ?? 0;

    return {
      dados: Array.isArray(dados) ? dados : [],
      paginas: typeof paginas === "number" ? paginas : 0,
    };
  } catch (error: any) {
    if (process.env.NODE_ENV === "development") {
      console.error("Erro ao carregar clientes CEM DELPHI:", {
        url,
        error: error?.response?.data || error?.message,
        status: error?.response?.status,
      });
    }

    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      error?.response?.data?.message ||
      "Erro ao carregar clientes CEM DELPHI";

    if (error?.response?.status !== 401) {
      getErrorsByApi(error, errorMessage);
    }

    return {
      dados: [],
      paginas: 0,
    };
  }
};

/**
 * Obtém o IdSerial de um cliente CEM DELPHI.
 * 
 * Endpoint: GET /api/Serial/IdSerial/{serial}/{documento}
 * 
 * Mantém uso da API antiga pois envolve lógica de criação automática
 * de serial + liberações padrão que ainda não foi migrada.
 */
export const obterIdSerial = async (
  serial: string,
  documento?: string
): Promise<number> => {
  try {
    const documentoParam = documento || "null";
    const url = `/Serial/IdSerial/${encodeURIComponent(serial)}/${encodeURIComponent(documentoParam)}`;

    const { data } = await apiAntigo.get<IIdSerialResponse>(url);

    return data.idSerial ?? data.IdSerial;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      error?.response?.data?.message ||
      "Erro ao obter IdSerial do cliente";

    getErrorsByApi(error, errorMessage);

    throw error;
  }
};
